import axios from 'axios'
import { API_BASE_URL } from '@/constants/env'

function getAdminToken() {
  return sessionStorage.getItem('adminToken')
}

function clearAdminToken() {
  sessionStorage.removeItem('adminToken')
  localStorage.removeItem('adminToken')
  localStorage.removeItem('token')
}

const http = axios.create({
  baseURL: API_BASE_URL,
})

http.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      clearAdminToken()
    }
    return Promise.reject(error)
  }
)

export function unwrap(response) {
  return response && response.data && Object.prototype.hasOwnProperty.call(response.data, 'data')
    ? response.data.data
    : response.data
}

export function getErrorMessage(error, fallback = 'Ocurrio un error. Intenta de nuevo.') {
  if (error && error.response && error.response.data && error.response.data.message) return error.response.data.message
  if (error && error.message) return error.message
  return fallback
}

export default http
